<template>
  <Teleport to="body">
    <Notification ref="notif" />
    <div id="loader">
      <ProgressSpinner v-show="isLoading" />
    </div>
  </Teleport>
  <div id="mainContainer">
    <NavComponent></NavComponent>
    <div id="main">
      <div class="col-2 col-offset-5">

      </div>
      <RouterView />
    </div>
    <FooterComponent id="footer"></FooterComponent>
  </div>
</template>

<script setup lang="ts">
import { onMounted, ref, watch } from 'vue';
import { RouterView } from 'vue-router';
import { isLoading, notifMessage, notifType, notifId } from '@/services/AppService';
import Notification from '@/components/Notification.vue';
import NavComponent from './components/core/NavComponent.vue';
import FooterComponent from './components/core/FooterComponent.vue';

const notif = ref();


onMounted(async () => {
  watch(notifId, () => {
    notif.value.showAlert(notifMessage.value, notifType.value);
  });
});

</script>

<style scoped>
#mainContainer {
  margin: 0;
  min-height: 100vh;
  display: grid;
  grid-template-rows: auto 1fr auto;
}

#loader {
  position: fixed;
  left: 0;
  right: 0;
  top: 40%;
  margin-left: auto;
  margin-right: auto;
  width: 100px;
  z-index: 9999;
}
</style>
